module.exports = __webpack_public_path__ + "static/media/booth.fe722741.png";